import { create } from 'zustand';

interface State {
  isCsDetailActive: boolean;
  headerHeight: number;
  headerRef: any;
  triggerAddressSearch: boolean;
  hasNewSearch: boolean;
  map: google.maps.Map | null;
  setIsCsDetailActive: (value: any) => void;
  setHeaderHeight: (value: any) => void;
  setHeaderRef: (value: any) => void;
  setTriggerAddressSearch: (value: boolean) => void;
  setHasNewSearch: (value: boolean) => void;
  setMap: (value: google.maps.Map | null) => void;
}

export const useMapViewStore = create<State>((set) => ({
  isCsDetailActive: false,
  headerHeight: 0,
  headerRef: null,
  triggerAddressSearch: false,
  hasNewSearch: false,
  map: null,
  setIsCsDetailActive: (value) => set(() => ({ isCsDetailActive: value })),
  setHeaderHeight: (value) => set(() => ({ headerHeight: value })),
  setHeaderRef: (value) => set(() => ({ headerRef: value })),
  setTriggerAddressSearch: (value) =>
    set(() => ({ triggerAddressSearch: value })),
  setHasNewSearch: (value) => set(() => ({ hasNewSearch: value })),
  setMap: (value) => set(() => ({ map: value })),
}));
